import { Suspense, createContext, useState, useMemo, useRef } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import {BrowserRouter} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import muiSFStateTheme from "~/themes/muiSFStateTheme.js";
import { StyledEngineProvider } from '@mui/styled-engine';

const ColorModeContext = createContext({ toggleColorMode: () => {} });
const FirstRenderContext = createContext({isFirstRender: () => {} });

// eslint-disable-next-line react/prop-types
function App({routes}) {
    const [mode, setMode] = useState("light");
    const firstLocation = useRef(location.href);
    const isFirstRender = useRef('true');
    const colorMode = useMemo(
        () => ({
            toggleColorMode: mode => {
                if (typeof mode !== 'undefined') {setMode(mode ? 'dark' : 'light')}
            },
        }),
        []
    );
    const firstRender = useMemo(
        () => ({
                isFirstRender: () => {
                    if (location.href !== firstLocation.current) isFirstRender.current = false;
                    return isFirstRender.current;
                }
            }),
        [location.href]
    );

    const theme = useMemo(
        () => createTheme({...muiSFStateTheme,
            palette: {
                ...muiSFStateTheme.palette,
                mode,
            },
        }),
        [mode],
    );

    return <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
        <Suspense fallback={<div/>}>
            <FirstRenderContext.Provider value={firstRender}>
                <ColorModeContext.Provider value={colorMode}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            {routes}
                        </ThemeProvider>
                    </StyledEngineProvider>
                </ColorModeContext.Provider>
            </FirstRenderContext.Provider>
        </Suspense>
    </BrowserRouter>
}

export default App;
export {ColorModeContext, FirstRenderContext};
